export default __webpack_public_path__ + "assets/arrow_r.d9b59f40.svg";